import axios from 'axios';
import type { HeadersDefaults } from 'axios';
import { API_URL } from '@/configs';

const http = axios.create({
  baseURL: API_URL,
});

http.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // if (error.response?.status === 401) {
    //   localStorage.clear();
    //   window.location.href = '/login';
    //   return Promise.reject(error);
    // }

    // Extract error message from response data
    // Try to get the error object or message from the response
    const errorData = error?.response?.data;

    // If it's already an object with error/message, return it as is
    if (typeof errorData === 'object' && errorData !== null) {
      return Promise.reject(errorData);
    }

    // Otherwise return the error data string or a fallback
    const errMessage: string = errorData || 'Unknown Error';
    return Promise.reject(errMessage);
  },
);

const setHTTPHeader = (header: HeadersDefaults['common']) => {
  http.defaults.headers.common = { ...http.defaults.headers.common, ...header };
};

export { http, setHTTPHeader };
